import { render, staticRenderFns } from "./KultuNautOverviewPageCustom.vue?vue&type=template&id=4ef2ce13&"
import script from "./KultuNautOverviewPageCustom.vue?vue&type=script&lang=js&"
export * from "./KultuNautOverviewPageCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports